import React, { Component } from 'react';

import { HashRouter as Router, Route } from 'react-router-dom'
import { Provider, observer } from 'mobx-react';

import store from '../store';
import shopStore from '../stores/shopStore';
import catalogStore from '../stores/catalogStore';
import DonationView from '../views/DonationView';
import AmountSelector from '../components/AmountSelector';
import { LOCATIONS } from '../constants/locations';
import { CURRENCIES } from '../constants/currencies';
import BillingForm from '../components/billing-form/BillingForm';

class Donation2App extends Component {
	constructor() {
		super();
		const context = window.tkcWidgetContext;
		store.netsuiteBaseUrl = context.netsuiteBaseUrl;
		store.guestSessionMode = true;		
		if (context.billingInfo) {
			shopStore.billingInfo.replace(context.billingInfo);
		}
		shopStore.cartItems.set(context.sku, {			
			sku: context.sku,			
			price: '',			
		})
	}
	
	handleLocationChange = event => {
		event.preventDefault();				
		shopStore.location.set(LOCATIONS[event.target.value]);
		let { currency } = shopStore;		
		const targetCurrencyCode = LOCATIONS[event.target.value].currencies[0];
		if (currency.get().code !== targetCurrencyCode) {
			currency.set(CURRENCIES[targetCurrencyCode]);
		}
	}	

	handleCurrencyChange = event => {		
		shopStore.currency.set(CURRENCIES[event.target.value]);	
	}	

	handleAmountClick = (event, amount) => {
		event.preventDefault();
		this.setAmount(amount);
	}	

	handleAmountChange = event => {
		event.preventDefault();
		this.setAmount(event.target.value);
	}	

	handleRecurrenceChange = event => {		
		shopStore.recurrenceFrequency.set(event.target.checked ? 1 : 0);
	}

	setAmount(amount) {
		const context = window.tkcWidgetContext;
		if (!isNaN(amount)) {
			shopStore.cartItems.set(context.sku, {
				sku: context.sku,
				price: amount,
			})
		}
	} 

	renderLocationSelect() {			
		return (
			<span className="text-muted">
				<label>Select the organization to receive your donation</label>
				<select                   								 
					className="form-control rounded-0" 
					name="location"								
					value={shopStore.location.get().netsuiteId}
					onChange={this.handleLocationChange}
				>
					{Object.keys(LOCATIONS).map(id =>
						<option key={LOCATIONS[id].netsuiteId} value={LOCATIONS[id].netsuiteId}>
							{LOCATIONS[id].name}
						</option>							
					)}																																				
				</select>						
			</span>
		);
	}	

	renderCurrencyChooser() {
		let currencies = [];		
		shopStore.location.get().currencies.map(code =>
			currencies.push(CURRENCIES[code])
		)
		return (
			<span>				
				<label className="text-muted">Select currency</label>				
				{currencies.map(cur => (		
					<div className="form-check" key={cur.code}>							
						<input 
							className="form-check-input" 
							type="radio" 
							value={cur.id} 
							checked={shopStore.currency.get().id === cur.id}
							onChange={this.handleCurrencyChange}
						/>
						<label className="form-check-label">
							{cur.name + ' (' + cur.code + ')'}
						</label>
					</div>		
				))}					
			</span>
		);
	}	

	renderAmountChooser() {
		return (
			<span>				
				{window.tkcWidgetContext.amounts.map(amount =>
					<button 
						key={amount}
						className="btn btn-outline-secondary rounded-0 px-4 mb-2 mr-3" 						
						onClick={event => this.handleAmountClick(event, amount)}
					>
						{shopStore.currency.get().symbol + amount}
					</button>
				)}
				{/*
				<button 
					className="btn btn-secondary rounded-0 px-5 mb-2 mr-4" 
					onClick={this.handleOtherAmountClick}
				>
					Other
				</button>
				*/}
			</span>
		);	
	}

	renderAmountField() {
		return (			
			<div className="input-group">
				<div className="input-group-prepend">
					<div className="input-group-text rounded-0">
						{shopStore.currency.get().code} {shopStore.currency.get().symbol}
					</div>
				</div>
				<input 
					className="form-control rounded-0"
					value={shopStore.cartItems.get(window.tkcWidgetContext.sku).price}										
					onChange={this.handleAmountChange}
					placeholder="Other Amount..."
				/>
			</div>			
		);
	}

	renderRecurrenceField() {
		return (
			<div className="form-check">
				<input 
						type="checkbox" 
						className="form-check-input" 
						name="monthly" 
						checked={shopStore.recurrenceFrequency.get()}							
						onChange={this.handleRecurrenceChange}							
				/>					
				<label className="form-check-label">
					<strong>Make this a Monthly Gift.</strong>
					<br />
					Your gift will be charged on a monthly basis. You may cancel at any time.
				</label>
			</div>	
		);	
	}

  	render() {	
		const context = window.tkcWidgetContext;				
		return (
			<div className="container">								
				<div className="row">
					<div className="col-12">
						<h3 className="font-weight-bold">Donation Information</h3>
					</div>							
					<div className="col-12 form-group">
						{this.renderLocationSelect()}
					</div>	
					{shopStore.location.get().currencies.length > 1 &&				
					<div className="col-12 form-group">
						{this.renderCurrencyChooser()}
					</div>		
	  				}
					<div className="col-12 form-group">
						{this.renderAmountChooser()}
					</div>	
					<div className="col-12 form-group">
						{this.renderAmountField()}
					</div>			
					<div className="col-12 form-group">
						{this.renderRecurrenceField()}
					</div>	
				</div>
				<BillingForm submitLabel='Donate' />					
			</div>
		);
		
  	}

}

export default observer(Donation2App);



// WEBPACK FOOTER //
// ./src/apps/Donation2App.js